module.exports = {"TXTWCL_Loading_cashier":{"id":"TXTWCL_Loading_cashier","defaultMessage":"正在載入出納櫃檯"}}